export function hasDecimal(number: number): boolean {
  return number % 1 !== 0;
}
export function removeDecimals(number: number): number {
  return Math.floor(number);
}
